'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _query = require('utilities/query');

var _systemIngredients = require('./system-ingredients.component');

var _systemIngredients2 = _interopRequireDefault(_systemIngredients);

var _systemIngredients3 = require('./system-ingredients.service');

var _systemIngredients4 = _interopRequireDefault(_systemIngredients3);

var _systemIngredientForm = require('./system-ingredient-form/system-ingredient-form.module');

var _systemIngredientForm2 = _interopRequireDefault(_systemIngredientForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.admin.system-ingredients', [_angularUiRouter2.default, _systemIngredientForm2.default]).component('systemIngredients', _systemIngredients2.default).service('SystemIngredientsService', _systemIngredients4.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('systemIngredients', {
    parent: 'admin',
    url: '/system-ingredients',
    component: 'systemIngredients',
    resolve: {
      flex: function flex() {
        return '100';
      },
      layout: function layout() {
        return 'column';
      },
      query: function query(SystemIngredientsService) {
        return SystemIngredientsService.getDefaultQuery();
      },
      ingredients: function ingredients(query, SystemIngredientsService) {
        return SystemIngredientsService.search(query).then(function (r) {
          return (0, _query.transformODataResponse)(r);
        });
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/admin/system-ingredients/system-ingredients.module.js